/**
 * Works用Swiper初期化モジュール
 *
 * 製作事例スライダーの初期化を行います。
 */

/**
 * Works用スライダーの初期化
 */
export function initWorksSwiper() {
  // Swiperが読み込まれているか確認
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper is not loaded');
    return;
  }

  const worksSwiper = document.querySelector('.js-swiper-works');
  if (!worksSwiper) return;

  const prevBtn = document.querySelector('.js-works-prev');
  const nextBtn = document.querySelector('.js-works-next');
  const paginationEl = document.querySelector('.js-works-pagination');

  new Swiper('.js-swiper-works', {
    loop: true,
    // loopAdditionalSlides: 3,
    slidesPerView: 'auto',
    spaceBetween: 20, // Figma: gap:50
    speed: 800,
    centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    pagination: {
      el: paginationEl,
      clickable: true,
      bulletClass: 'm-works__pagination-dot',
      bulletActiveClass: 'm-works__pagination-dot--active',
    },
    breakpoints: {
      768: {
        spaceBetween: 50,
      },
    },
  });
}
